// extracted by mini-css-extract-plugin
export var mainContainer = "legalStyles-module--mainContainer--X8BoT";